require('./bootstrap');
require('es6-promise').polyfill();
require('promise.prototype.finally').shim();

window.Vue = require('vue');

// 価格だし
Vue.component('pricecheck', require('./components/Pricecheck.vue'));
// 価格だし(管理者)
Vue.component('pricecheck_admin', require('./components/PricecheckAdmin.vue'));
// 価格だしテキスト表示
Vue.component('pricecheck_text', require('./components/PricecheckText.vue'));
// モーダル
Vue.component('modal_base', require('./components/Modal.vue'));

const app = new Vue({
    el: '#content',
});

// $('.drawer-nav .drawer-menu .__unit__global .__unit__drop-item > a,' +
//   '.drawer-nav .drawer-menu .__unit__global .__unit__drop-item > span').on('click', function(e) {
//   e.preventDefault();
//   if($(this).hasClass('__state__active')) {
//     $(this).removeClass('__state__active');
//     $(this).parents('li').find('.__unit__drop-inner').hide(function() {
//       $('.drawer').drawer('refresh');
//     });
//   } else {
//     $(this).addClass('__state__active');
//     $(this).parents('li').find('.__unit__drop-inner').slideDown('fast', function() {
//       $('.drawer').drawer('refresh');
//     });
//   }
// });


// WEBPACK FOOTER //
// ./resources/assets/js/app.js